import { useTranslation } from 'react-i18next'

import { useQuery } from 'services/query'
import { getCommunities } from 'api/communities'
import { Skeleton } from 'App/components/common/Skeleton'
import { UnityHubChannelIcon } from 'App/components/UnityHub'

import { UnityHubRoomsNavCollapse } from '../UnityHubRoomsNavCollapse'
import { UnityHubRoomNavLink } from '../UnityHubRoomNavLink'

interface Props {
  eventId: string
}

export const UnityHubRoomsNavCommunitiesList = ({ eventId }: Props) => {
  const { t } = useTranslation()

  const { data, isFetching } = useQuery({
    queryKey: ['event-communities', eventId],
    queryFn: () => getCommunities({ eventId })
  })

  if (isFetching) {
    return <Skeleton />
  }

  return (
    <UnityHubRoomsNavCollapse
      variant="broadcast"
      title={t('unityHub.channelsList.communitiesLabel')}
      localStorageKey={`event-communities-${eventId}`}
    >
      {data?.results?.map(({ id, title }) => (
        <UnityHubRoomNavLink
          key={id}
          name={title}
          to={`/communities/${id}/info`}
          icon={<UnityHubChannelIcon variant="communities" />}
        />
      ))}
    </UnityHubRoomsNavCollapse>
  )
}
